// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"311":"7c69f7a7064bdce547e3","531":"63f8d227b1056ed8b3a6","825":"99e46866de665ac65d7c"}[chunkId] + ".chunk.min.js";
};